// extracted by mini-css-extract-plugin
export default {"container":"countrydetail_container__n8Sc7","button":"countrydetail_button__hEAXP","actDetail":"countrydetail_actDetail__LqmEr"};